import type Maybe from 'true-myth/maybe';

import type { Customization } from '~/shared/customization/customization';

export const setFavicon = (customization: Maybe<Customization>): void => {
    const faviconUrl = customization.get('uiConfiguration').get('assets').get('faviconUrl');

    if (faviconUrl.isJust) {
        const link: HTMLLinkElement =
            globalThis.document.querySelector("link[rel*='icon']") ?? globalThis.document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = faviconUrl.value.href;

        globalThis.document.getElementsByTagName('head')[0]?.appendChild(link);
    }
};
